export const shadows = {
    card: '0 0 8px 0 rgba(0, 0, 0, 0.2)',
    regular: '4px 4px 20px 2px rgba(0,0,0,.19)',
    dropdown: '0px 4px 4px rgba(0, 0, 0, 0.05), 0px 5px 25px rgba(0, 0, 0, 0.1);',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhZG93cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aGVtZS9zaGFkb3dzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBZ0I7SUFDbEMsSUFBSSxFQUFFLDhCQUE4QjtJQUNwQyxPQUFPLEVBQUUsa0NBQWtDO0lBQzNDLFFBQVEsRUFBRSxtRUFBbUU7Q0FDOUUsQ0FBQyJ9